/**
 * High-contrast chrome for the standalone ICS-215 legacy table on dark IAP
 * panels.
 */

export const ICS215_OUTLINE_BTN =
  'tw:border-neutral-500 tw:bg-neutral-900 tw:text-white tw:hover:bg-neutral-800';

export const ICS215_ICON_BTN = 'tw:text-white! tw:hover:bg-neutral-800';

export const ICS215_TRASH_BTN =
  'tw:text-red-500! tw:hover:text-red-400! tw:disabled:text-red-500/40!';

export const ICS215_INPUT =
  'tw:w-full tw:min-w-0 tw:rounded-md tw:border tw:border-neutral-500 tw:bg-neutral-900 tw:px-2 tw:text-xs tw:text-white tw:outline-none tw:placeholder:text-neutral-400';

export const ICS215_RHN_INPUT =
  'tw:h-7 tw:w-full tw:rounded tw:border tw:border-neutral-500 tw:bg-transparent tw:px-1 tw:text-center tw:text-[11px] tw:text-white tw:outline-none';
